import { createSelector } from 'reselect';

import { isMobileUserAgent } from '../utils/isMobileUserAgent.mjs';
import { isNode } from '../utils/environment.mjs';
import { isRebranded } from '../utils/isRebranded.mjs';
import { getIsInProductMagazine } from './getIsInProductMagazine.mjs';
import { getEdition } from './getEdition.mjs';

const hasClosedDownloadAppBanner = (state) => state.downloadAppBanner.hasClosedDownloadAppBanner;

const isEligibleForDownloadAppBannerExperiment = createSelector(
  getIsInProductMagazine,
  getEdition,
  hasClosedDownloadAppBanner,
  (isInProduct, edition, hasClosed) => {
    if (isNode()) {
      return false;
    }
    return (
      !hasClosed &&
      !isInProduct &&
      edition === 'en' &&
      isRebranded &&
      isMobileUserAgent(navigator.userAgent)
    );
  },
);

export { hasClosedDownloadAppBanner, isEligibleForDownloadAppBannerExperiment };
